import type {
    GetPlaceDTOResponse,
    CategoryData,
    PostPlaceDTO
} from "@hitit/api/src/types"

export type ImageFile = {
    file: File,
    name: string,
    type: string
}

// Note : Image로 변경 예정임. 
export type ImageData = {
    id: string
    src?: string | null,
    edit?: ImageFile | null
}

export type PlaceAddress = {
    lat: string,
}

export type Menu = {
    desc?: string;
    name: string;
    show: boolean;
    price: number;
    displaySort: number;
    uid: string;
};

export type Category = {
    name: string;
    id: string;
    displaySort: number;
    menus: Menu[];
};

export type ChangeableDisplayValue = {
    mainImage: ImageData
    storeDescription: string
    hashTags: string[]
    albumImages: ImageData[]
    categories: Category[],
    callNumber: string,
    openHours: OpenHour[],
    breaktime: string
    youtube: string,
    instagram: string,
    naverBlog: string,
}

export type StaticDisplayValue = {
    storeName: string;
    addressData: {
        position: {
            lat: string;
            lng: string;
        };
        road: string;
        numb: string;
    };
    storeCategory: string | undefined;
}
export type Day = "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun"

export type OpenHour = {
    day: Day,
    open: string,
    close: string,
    dayOff: boolean
}

export enum DayIndex {
    Mon,
    Tue,
    Wed,
    Thu,
    Fri,
    Sat,
    Sun
}
export type MixinPlacedata = PlaceDTO & { categories: CategoryData[] }
export type PostMixinPlaceData = PostPlaceDTO & { categories?: CategoryData[] }
export type PlaceDTO = GetPlaceDTOResponse["placeDTO"]